/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface RecruitInterviewEvaluation { 
    id?: string;
    criteria_name?: string;
    criteria_description?: string;
    evaluation_collection?: string;
    comment?: string;
    is_additionnal?: boolean;
    recruit_interview_result_id?: string;
    created_at?: Date;
    created_by?: string;
    modified_at?: Date;
    modified_by?: string;
}